function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* *********************************** */

/* Generated code, please do not touch */

/* *********************************** */
import React from "react";
import PropTypes from "prop-types";
import { StyledIcon } from "../../../../foundation/Icon/Icon.style";

var Close = function Close(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement(StyledIcon, _extends({
    width: 24,
    height: 24
  }, props, {
    viewBox: "0 0 24 24",
    ref: svgRef ? svgRef : null
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 10.947l5.31-5.311a.745.745 0 011.054 1.053L13.054 12l5.31 5.31a.745.745 0 11-1.053 1.054L12 13.054l-5.31 5.31a.745.745 0 11-1.054-1.053L10.946 12l-5.31-5.31a.745.745 0 111.053-1.054L12 10.946z"
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Close, _extends({
    svgRef: ref
  }, props));
});
ForwardRef.defaultProps = {
  color: "black",
  size: "sm"
};
ForwardRef.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOf(["sm", "md", "lg", "xlg", "xxlg", "xxxlg"])
};
export default ForwardRef;